define('views/modules/calendar/nutrition/nutrient/form/nutrient-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    // views
    'views/parts/list/list',
    'views/modules/calendar/nutrition/nutrient/form/nutrient-form-item'
    // templates
    // 'text!templates/modules/calendar/nutrition/nutrient/form/nutrient-form.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    // views
    VList,
    VNutrientFormItem
    // templates
    // TNutrientForm
) {

    var VNutrientForm = VList.extend({
        // template: TNutrientForm,
        item: VNutrientFormItem,
        initialize: function(options) {
            options = options || {};
            var model = this.model;

            // this.view = {
            //     form: new VFoodForm({
            //         model: model
            //     }),
            // };

        },

        // render: function() {
        //     this.$el.empty()
        //         .append(Mustache.render(this.template, Mustache.getContext({
        //             name: this.model.get('name'),
        //         })));
        //     return this;
        // },

    });

    return VNutrientForm;

});

